export { default } from './IssueTableSkeleton';
